/**
 * Hannes & Bianca's invited-guest list. Used as the default seed when the
 * admin clicks "Importeer aanvanklike lys" on the /admin Gas-lys tab.
 * Editable here directly — names trimmed and deduped server-side on import.
 */
export const INITIAL_GUEST_LIST: string[] = [
  "Oom Kobie Strydom",
  "Tannie Loraine Strydom",
  "Jan Strydom",
  "Christelle Strydom",
  "Frikkie Strydom",
  "Joanline Strydom",
  "Jan Strydom Jnr",
  "Rochelle Strydom",
  "Willem Strydom",
  "Rebekka Strydom",
  "Lonita Strydom",
  "Christelle Strydom Jnr",
  "Jan-Hendrik Strydom",
  "Cine Strydom",
  "Ouma Anri Strydom",
  "Johan De Bruyn",
  "Juanita De Bruyn",
  "Jahn De Bruyn",
  "Frederik De Bruyn",
  "Japie De Bruyn",
  "Bianca De Bruyn",
  "Oupa Willie Burger",
  "Francois Burger",
  "Lollie Burger",
  "Mia Burger",
  "Franco Burger",
  "Elzabe Engelbregt",
  "Anneke Kampfer",
  "Henri Kampfer",
  "Jana Engelbregt",
  "Micheal Engelbregt",
  "Micheal se Verloofde",
  "Oom Stephen van Vuuren",
  "Tannie Anrolie van Vuuren",
  "Tannie Sanelle Streicher",
  "Oom Carl Streicher",
  "Oom Carel Le Roux",
  "Tannie Jenny Le Roux",
  "Gert van der Vyver",
  "Charlene van der Vyver",
  "Gerdus van der Vyver",
  "Charne van der Vyver",
  "Ouma Mercia Parker",
  "Oupa Willis Parker",
  "Ouma Bessie van der Vyver",
  "Oupa Gert van der Vyver",
  "Ouma Hannetjie de Beer",
  "Tannie Marisa van der Vyver",
  "Oom Jannie van der Vyver",
  "Tannie Collete van der Vyver",
  "Tannie Sanmarie Odendaal",
  "Tannie Liezel van Zyl",
  "Oom Pierre van Zyl",
  "Wian van Zyl",
  "Hanro van Zyl",
  "Anke Weyers",
  "Jaco De Beer",
  "Lizri Weyers",
  "Jacobus Lizri se kerel",
  "Tannie Erika Weyers",
  "Oom Faf Weyers",
  "Tannie Anli Grobler",
  "Oom Hennie Grobler",
  "Rudolf Grobler",
  "Tannie Mariette Kriek",
  "Oom Rhyno Kriek",
  "Tannie Anda Redpath",
  "Oom Gerrit Redpath",
  "Tannie Anneliese Joubert",
  "Oom Niel Joubert",
  "Tannie Ida van der Merwe",
  "Oom Pierre van der Merwe",
  "Tannie Yolandi Kotze",
  "Oom Johan Kotze",
  "Kara Kotze",
  "Kaity Kotze",
  "Tannie Chrisnette",
  "Dylen Smit",
  "Dian Geerkens",
  "Adriaan Du Toit",
  "Albertus De Klerk",
  "Lexi",
  "Franco Aucamp",
  "Nina Aucamp",
  "Danie Geerkens",
  "Caleb Braack",
  "Pierre Labuschagne",
  "Danhard Russow",
  "Zirk De Klerk",
  "Francois De Kock",
  "Dewald Le Grange",
  "Gina Moolman",
  "Emile Streicher",
  "Elbe Streicher",
  "John Faul",
  "Christinet Zaal",
  "Jaco Classen",
  "Grete Classen",
  "Christiaan Jacobs",
  "Keegan Bylevelt",
  "Charlene Bylevelt",
  "Christiaan Le Roux",
  "Jaco Le Roux",
  "Leander Threon",
  "Divan Meyer",
  "Janco Meyer",
  "Minette Van Zyl",
  "Muffin van der Merwe",
  "Janco Van Vuuren",
  "Dirk Venter",
  "Chris Vermaak",
  "Jomarni Vermaak",
  "Johan Weideman",
  "Petrie Faber",
  "Maritz Grobelaar",
  "Waldo Strydom",
  "Zander Boshof",
  "Carolyn van der Merwe",
  "Mandie De Wet",
  "Izelle Bekker",
  "Deon Duwenhage",
  "Tiane Theunissen",
  "Dillan Schults",
  "Carmen Fichardt",
  "Zander Du Plessis",
  "Annegret Joubert",
  "Haynard Anna se Kerel",
  "Karla Burger",
  "Lianke van Niekerk",
  "Hennie Lillie se Kerel",
  "Anika Laubsher",
  "Idelete Liebnberg",
  "Mia Moolman",
  "Albert Mia se kerel",
  "Deanri Snyman",
  "Pieter Hoogenbozem",
  "Mia Pretorius",
  "Lise Besuidenhout",
  "Jana Redpath",
  "Fredalette",
  "Andre (Fredalette se man)",
  "Emma van der Merwe",
  "Micheal (Emma Se Verloofde)",
  "Lalla Lalla",
  "Refilwe Tsotsetsi",
  "Romain Hattingh",
  "Ruan Hattingh",
  "Heinrich Graupner",
  "Cara Graupner",
  "Edrich Graupner",
  "Christo Franken",
  "Rushane Alexander",
  "Christo Horn",
  "Margole Horn",
  "Ds Schalk Kok",
  "Tannie Magda Kok",
  "Arle",
  "Arle se Man",
  "DJ",
  "Hannes Strydom",
  "Bianca Strydom",
];
